import classNames from 'classnames/bind';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    item: useRef(),
    repeat: useRef(),
  }).current;

  useEffect(() => {
    domRefs.item.current.value = command.data.item;
    domRefs.repeat.current.value = command.data.repeat;
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(Math.trunc(e.target.value));
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Item Number">
        <FieldNumber ref={domRefs.item} name="item" min={1} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Repeat">
        <FieldNumber ref={domRefs.repeat} name="repeat" min={1} onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
